export const MESSAGES = {
    SERVER_ERROR: 'Unable to connect with server.',
    LOGGED_OUT: 'Logged out successfully',
    AGENT_CREATED: 'Agent created successfully',
    AGENT_DELETED: 'Agent deleted successfully',
    AGENT_SUSPENDED: 'Agent suspended successfully',
    AGENT_RESUME: 'Agent resume successfully.',
    AGENT_REJECTED: 'Agent rejected successfully',
    AGENT_APPROVED: 'Agent approved successfully',
    AGENT_UPDATED: 'Agent updated successfully',
    AGENT_EMAIL_VERIFICATION : 'Agent email verification is pending',
    FUND_DEPOSIT : 'Fund deposit successfully',
    FUND_WITHDRAW: 'Fund withdraw successfully',
    BATCH_CREATED: 'Batch created successfully',
    FILE_DOWNLOADED: 'File downloaded successfully',
    FILE_UPLOADED: 'file uploaded successfully',
    AGENT_LIMIT_UPDATED: 'Agent Limit Updated Successfully',
    AGENT_LIMIT_CREATED:'Agent Limit Created',
    AGENT_COMMISON_CREATED: 'Agent Commission Created Successfully',
    AGENT_COMMSION_DELETED: 'Agent Commission deleted successfully',
    AGENT_COMSION_RESUME:'Agent Commission resume successfully',
    AGENT_COMMSION_SUSPENDED: 'Agent Commission suspended successfully',
    AGENT_LIMIT_DELETED: 'Agent Limit deleted successfully',
    AGENT_LIMIT_RESUME:'Agent Limit resume successfully',
    AGENT_LIMIT_SUSPENDED: 'Agent Limit suspended successfully',
    COMM_GRP_UPDATED: 'Commission Group updated successfully',
    PAYMENT_DEL:'payment method deleted successfully',
    KEY_CREATE:'Key created successfully',
    KEY_UPDATE:'Key updated successfully',
    CALLBACK_URL_CREATE:'Callback URL updated successfully',
    CALLBACK_URL_UPDATE:'Callback URL created successfully',
    HOOK_UPDATE:'Hook updated successfully',
    HOOK_CREATE:'Hook created successfully',
    GATEWAY_CREATE:'Gateway created successfully',
    UPLOAD_IMG: 'Please upload image',
    TXT_COPIED: 'Text Copied',
    TXT_CPY_FAILED: 'Failed to copy text',
    CRYPTO_APPROVED : 'Crypto approved successfully',
    CRYPTO_REJECTED : 'Crypto rejected successfully',
    CRYPTO_BUY: 'Crypto buy successfully',
    CRYPTO_SELL: 'Crypto sell successfully',
    CONFIG_UPDATE :'Config updated successfully',
    DIST_CREATED: 'Distributor created successfully',
    DIST_DELETED: 'Distributor deleted successfully',
    DIST_SUSPENDED: 'Distributor suspended successfully',
    DIST_RESUME: 'Distributor resume successfully.',
    DIST_UPDATED: 'Distributor updated successfully',
    PWD_RESET : 'Password reset successfully',
    MCH_CREATED: 'Merchant created successfully',
    MCH_DELETED: 'Merchant deleted successfully',
    MCH_SUSPENDED: 'Merchant suspended successfully',
    MCH_RESUME: 'Merchant resume successfully.',
    MCH_UPDATED: 'Merchant updated successfully',
    PRF_UPDATED : 'Profile updated successfully',
    PWD_CHNG: 'Password changed successfully',
    TCK_CREATD: 'Ticket creadted successsfully',
    TCK_CLSD: 'Ticket closed successfully',
    TCK_RPLY: 'Reply to ticket successfully',
    USR_CREATED: 'User created successfully',
    USR_DELETED: 'User deleted successfully',
    USR_SUSPENDED: 'User suspended successfully',
    USR_RESUME: 'User resume successfully.',
    USR_UPDATED: 'User updated successfully',
    NGT_NT_ALLOWED : 'Negative values not allowed',
    TO_AMT_BLNK: 'To amount should not be blank',
    AMOUNT_VALID_LESS: 'To Amount should be less than the next From Amount',
    AMOUNT_VALID_LESS_FRM:'To Amount should not be less than From Amount',
    AUTO_PAY : 'Agent settings updated successfully'

    
  };